import ApplyContent from 'components/apply-shared/apply-content';
import { ButtonGroup, Flex, List, Text } from '@chakra-ui/react';
import ListItem from 'common/components/list-item';
import { FaCalendar, FaHouseChimney } from 'react-icons/fa6';
import Button from 'common/components/button';

const StartQuote = ({ onNextClick, isLoading }) => {
  return (
    <div className='flex flex-col w-full h-full'>
      <ApplyContent>
        <Flex className='flex-col gap-4 text-center items-center h-full p-8'>
          <Text className='text-2xl font-medium'>
            Get a Quote for ReLease
          </Text>
          <Text className='text-base text-gray-500 max-w-md'>
            We'll ask a few questions about your lease to generate a
            personalized quote for you. It only takes a minute.
          </Text>
          <List className='flex flex-col w-fit text-left gap-4 max-w-sm p-6 rounded-lg border border-gray-200 my-6'>
            <ListItem
              title='Lease Dates'
              description=""
              ListIcon={FaCalendar}
              line
            >
              <Text className='text-base text-gray-500'>
                Let us know the status of your next lease agreement. Whether you’ve signed or not, you can get covered by ReLease.
              </Text>
            </ListItem>
            <ListItem
              title='Rental Details'
              ListIcon={FaHouseChimney}
            >
              <Text className='text-base text-gray-500'>
                Let us know about where you're planning to rent, and whether it's at a ReLease-Enabled Community.                
              </Text>
            </ListItem>
          </List>
          <ButtonGroup className='pb-8'>
          <Button
            onClick={() => onNextClick()}
            title='Get Started'
            wFull={false}
            size='lg'
            loading={isLoading}
          />
          </ButtonGroup>
        </Flex>
      </ApplyContent>
    </div>
  );
};

export default StartQuote;